import { render, staticRenderFns } from "./AssetBoard.vue?vue&type=template&id=e9f25c40&scoped=true"
import script from "./AssetBoard.vue?vue&type=script&lang=js"
export * from "./AssetBoard.vue?vue&type=script&lang=js"
import style0 from "./AssetBoard.vue?vue&type=style&index=0&id=e9f25c40&prod&scoped=true&lang=css"
import style1 from "./AssetBoard.vue?vue&type=style&index=1&id=e9f25c40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f25c40",
  null
  
)

export default component.exports